var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418 302L437 392L530 327Z",
    fill: "#031325",
    stroke: "#031325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 392L516 409L530 327Z",
    fill: "#031325",
    stroke: "#031325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 409L570 403L530 327Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 392L487 470L516 409Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 409L487 470L570 403Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 276L511 207L530 327Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 327L511 207L418 302Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 403L597 276L530 327Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 423L425 490L437 392Z",
    fill: "#051528",
    stroke: "#051528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 392L425 490L487 470Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 162L320 278L418 302Z",
    fill: "#0c1b31",
    stroke: "#0c1b31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 302L300 423L437 392Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 278L300 423L418 302Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 207L385 162L418 302Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 276L584 176L511 207Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 207L479 112L385 162Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 403L681 305L597 276Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 276L702 193L584 176Z",
    fill: "#0c1b31",
    stroke: "#0c1b31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 176L479 112L511 207Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 470L596 526L570 403Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 403L717 405L681 305Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 600L596 526L487 470Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 112L387 114L385 162Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 173L226 278L320 278Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 173L320 278L385 162Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 278L215 378L300 423Z",
    fill: "#0c1b31",
    stroke: "#0c1b31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 423L289 519L425 490Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 490L471 600L487 470Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 487L289 519L300 423Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 114L273 173L385 162Z",
    fill: "#0c1b31",
    stroke: "#0c1b31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 278L215 378L320 278Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 526L717 405L570 403Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 600L471 600L425 490Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 600L412 600L425 490Z",
    fill: "#051528",
    stroke: "#051528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681 305L702 193L597 276Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 176L637 79L479 112Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 281L702 193L681 305Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 600L588 600L596 526Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596 526L703 517L717 405Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 600L703 517L596 526Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 519L332 600L425 490Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700 113L637 79L584 176Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 112L394 0L387 114Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 505L777 406L717 405Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 405L784 281L681 305Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 417L189 487L215 378Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 378L189 487L300 423Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 519L214 600L332 600Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 406L784 281L717 405Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 193L700 113L584 176Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 218L700 113L702 193Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 281L784 218L702 193Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 79L472 0L479 112Z",
    fill: "#051528",
    stroke: "#051528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 114L273 62L273 173Z",
    fill: "#0c1b31",
    stroke: "#0c1b31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 0L273 62L387 114Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 173L163 191L226 278Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 123L163 191L273 173Z",
    fill: "#051528",
    stroke: "#051528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 278L82 309L215 378Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 0L394 0L479 112Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 600L698 600L596 526Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 517L790 505L717 405Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 62L179 123L273 173Z",
    fill: "#031325",
    stroke: "#031325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 600L790 505L703 517Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777 406L900 300L784 281Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 202L794 71L784 218Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 487L214 600L289 519Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 79L628 0L472 0Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 0L628 0L637 79Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 0L637 79L700 113Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 0L301 0L387 114Z",
    fill: "#031325",
    stroke: "#031325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 62L224 0L179 123Z",
    fill: "#051528",
    stroke: "#051528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 91L103 212L163 191Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 191L103 212L226 278Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 487L121 526L214 600Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 212L82 309L226 278Z",
    fill: "#031325",
    stroke: "#031325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 600L763 600L703 517Z",
    fill: "#051528",
    stroke: "#051528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 309L82 417L215 378Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 417L121 526L189 487Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 0L224 0L273 62Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 123L95 91L163 191Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 202L784 218L784 281Z",
    fill: "#031325",
    stroke: "#031325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 218L794 71L700 113Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 71L720 0L700 113Z",
    fill: "#051528",
    stroke: "#051528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 415L777 406L900 480Z",
    fill: "#031325",
    stroke: "#031325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 415L900 300L777 406Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 480L777 406L790 505Z",
    fill: "#001122",
    stroke: "#001122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 262L0 412L82 309Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 0L95 91L179 123Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 300L900 202L784 281Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 600L900 480L790 505Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 504L97 600L121 526Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 526L97 600L214 600Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 309L0 412L82 417Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 417L0 504L121 526Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 262L82 309L103 212Z",
    fill: "#0c1b31",
    stroke: "#0c1b31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 230L0 262L103 212Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 103L0 230L103 212Z",
    fill: "#07172b",
    stroke: "#07172b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 90L829 0L794 71Z",
    fill: "#041426",
    stroke: "#041426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 71L829 0L720 0Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 412L0 504L82 417Z",
    fill: "#08182c",
    stroke: "#08182c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 202L900 90L794 71Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 600L900 600L790 505Z",
    fill: "#09192e",
    stroke: "#09192e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 0L72 0L95 91Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 91L0 103L103 212Z",
    fill: "#011223",
    stroke: "#011223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 0L0 103L95 91Z",
    fill: "#0c1b31",
    stroke: "#0c1b31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 504L0 600L97 600Z",
    fill: "#0b1a2f",
    stroke: "#0b1a2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 90L900 0L829 0Z",
    fill: "#061629",
    stroke: "#061629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 0L0 0L0 103Z",
    fill: "#09192e",
    stroke: "#09192e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgDark);
export default __webpack_public_path__ + "static/media/hero-bg-dark.f8bcea8023ec090fa76a1335107be7c7.svg";
export { ForwardRef as ReactComponent };